import { useCallback, useEffect, useState } from "react";
import { useShader } from "../use-shader";
export function useProgram({ gl, initialProgram, programs, showDebugInfo, controller }) {
    const { createProgram, removeProgram } = useShader({ gl, showDebugInfo });
    const [programResults, setProgramResults] = useState({});
    const [usedProgram, setUsedProgram] = useState();
    useEffect(() => {
        return () => {
            Object.values(programResults).forEach(removeProgram);
        };
    }, [programResults, removeProgram]);
    useEffect(() => {
        setProgramResults(results => {
            const newResults = Object.assign({}, results);
            const existingProgramIds = new Set();
            for (let id in results) {
                existingProgramIds.add(id);
            }
            programs === null || programs === void 0 ? void 0 : programs.forEach(program => {
                existingProgramIds.add(program.id);
                if (!results[program.id]) {
                    const result = createProgram(program);
                    if (result) {
                        newResults[program.id] = result;
                    }
                }
            });
            Object.entries(newResults).forEach(([programId, result]) => {
                if (!existingProgramIds.has(programId)) {
                    removeProgram(result);
                    delete newResults[programId];
                }
            });
            return newResults;
        });
    }, [...(programs !== null && programs !== void 0 ? programs : []), createProgram, removeProgram]);
    const setActiveProgram = useCallback((programId) => {
        if (gl && programId) {
            const result = programResults[programId];
            if (result === null || result === void 0 ? void 0 : result.program) {
                gl.useProgram(result.program);
                setUsedProgram(result.program);
                return true;
            }
        }
        return false;
    }, [gl, programResults]);
    const getUniformLocation = useCallback((name, programId) => {
        var _a, _b;
        if (gl) {
            const program = programId ? (_a = (programResults[programId])) === null || _a === void 0 ? void 0 : _a.program : usedProgram;
            if (program) {
                return (_b = gl.getUniformLocation(program, name)) !== null && _b !== void 0 ? _b : undefined;
            }
        }
    }, [gl, programResults, usedProgram]);
    useEffect(() => {
        if (controller) {
            controller.setActiveProgram = setActiveProgram;
            controller.getUniformLocation = getUniformLocation;
        }
    }, [controller, setActiveProgram, getUniformLocation]);
    useEffect(() => {
        if (gl && !usedProgram) {
            setActiveProgram(initialProgram !== null && initialProgram !== void 0 ? initialProgram : programs === null || programs === void 0 ? void 0 : programs[0].id);
        }
    }, [gl, initialProgram, setActiveProgram, usedProgram, programs]);
    return {
        usedProgram,
    };
}
